import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import frenchMessages from "ra-language-french";
import russianMessages from "ra-language-russian";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { raSupabaseFrenchMessages } from "ra-supabase-language-french";
import { englishCrmMessages } from "./englishCrmMessages";
import { frenchCrmMessages } from "./frenchCrmMessages";
import { russianCrmMessages } from "./russianCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const raSupabaseFrenchMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Consultez vos emails pour trouver le message de reinitialisation du mot de passe.",
    },
  },
};

const raSupabaseRussianMessagesOverride = {
  "ra-supabase": {
    auth: {
      email: "Email",
      confirm_password: "Подтвердите пароль",
      sign_in_with: "Войти через %{provider}",
      forgot_password: "Забыли пароль?",
      reset_password: "Сбросить пароль",
      password_reset:
        "Проверьте почту: мы отправили письмо для сброса пароля.",
      missing_tokens: "Отсутствуют access token и refresh token",
      back_to_login: "Вернуться ко входу",
    },
    reset_password: {
      forgot_password: "Забыли пароль?",
      forgot_password_details: "Введите email, и мы отправим инструкцию.",
    },
    set_password: {
      new_password: "Задайте пароль",
    },
    validation: {
      password_mismatch: "Пароли не совпадают",
    },
    oauth: {
      no_request: "Запрос авторизации не найден",
      approved: "Авторизация подтверждена",
      close_tab: "Теперь эту вкладку можно закрыть.",
      authorize: "Авторизовать приложение",
      authorize_details: "Это приложение запрашивает доступ к вашему аккаунту",
      permissions: "Запрашиваемые разрешения",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

const frenchCatalog = mergeTranslations(
  englishCatalog,
  frenchMessages,
  raSupabaseFrenchMessages,
  raSupabaseFrenchMessagesOverride,
  frenchCrmMessages,
);

const russianCatalog = mergeTranslations(
  englishCatalog,
  russianMessages,
  raSupabaseRussianMessagesOverride,
  russianCrmMessages,
);

export const getInitialLocale = (): "en" | "fr" | "ru" => {
  return "ru";
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "fr") {
      return frenchCatalog;
    }
    if (locale === "ru") {
      return russianCatalog;
    }
    return englishCatalog;
  },
  getInitialLocale(),
  [
    { locale: "ru", name: "Русский" },
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
